import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { t, tLoc } from '../../i18n/translate.js';
import styles from './GuardAccessDirection.module.scss.js';

var GuardWaterDirection = function GuardWaterDirection(_ref) {
  var visible = _ref.visible,
    waterLocation = _ref.waterLocation,
    onChange = _ref.onChange,
    error = _ref.error,
    overrideLabels = _ref.overrideLabels;
  var defaultLabels = {
    title: tLoc('MPLIB_GUARD_ACCESS_WATERVALVE_TITLE'),
    description: tLoc('MPLIB_GUARD_ACCESS_WATERVALVE_DESCRIPTION'),
    error: tLoc('MPLIB_GUARD_ACCESS_SIDEPANEL_INPUT_ERROR'),
    placeholder: t('MPLIB_GUARD_ACCESS_WATERVALVE_TITLE')
  };
  var mergedLabels = _objectSpread2(_objectSpread2({}, defaultLabels), overrideLabels);
  return visible ? /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("label", null, mergedLabels.title), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, mergedLabels.description), /*#__PURE__*/React.createElement("textarea", {
    className: styles.textarea,
    placeholder: mergedLabels.placeholder,
    name: "waterLocation",
    id: "waterLocation",
    value: waterLocation,
    maxLength: 700,
    onChange: onChange
  }), error && /*#__PURE__*/React.createElement("p", {
    className: styles.error
  }, " ", mergedLabels.error, " ")) : null;
};
GuardWaterDirection.propTypes = {
  visible: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  waterLocation: PropTypes.string,
  overrideLabels: PropTypes.shape({})
};
GuardWaterDirection.defaultProps = {
  waterLocation: '',
  error: false,
  overrideLabels: null
};

export { GuardWaterDirection };
